// Africa HR Summit - Color Palette (JS)
// Use this object to access theme colors in JS or Vue components
export const theme = {
  // Primary Brand Colors
  primary: "#228b22", // Forest Green
  primaryDark: "#1a472a", // Dark Forest
  primaryLight: "#4ade80", // Bright Green
  secondary: "#2d5f3f", // Hunter Green

  // Accent Colors
  accent: "#4ade80", // Bright Green
  success: "#22c55e", // Success Green
  successDark: "#16a34a", // Deep Success

  // Supporting Colors
  muted: "#a8d5a8", // Light Green
  backgroundLight: "#f8fdf8", // Mint White
  white: "#ffffff", // Pure White

  // Neutral Colors
  textPrimary: "#333333", // Dark Gray
  textSecondary: "#666666", // Medium Gray
  textMuted: "#888888", // Light Gray
  background: "#f8f9fa", // Background Gray

  // Semantic Colors
  error: "#dc2626", // Red
  warning: "#d97706", // Orange
  info: "#2563eb", // Blue

  // Gradients
  gradientPrimary: "linear-gradient(135deg, #1a472a 0%, #2d5f3f 100%)",
  gradientCTA: "linear-gradient(135deg, #4ade80 0%, #22c55e 100%)",
  gradientHover: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
};
